export default __webpack_public_path__ + "static/media/header.3632b50d.webp";